(function () {
  const instances = new WeakMap();
  const videoObservers = new WeakMap();
  const activeVideos = new Set();

  function playVideo(video) {
    if (!video || document.hidden) return;

    video.muted = true;
    video.defaultMuted = true;
    video.autoplay = true;
    video.playsInline = true;
    video.setAttribute("muted", "");
    video.setAttribute("autoplay", "");
    video.setAttribute("playsinline", "");

    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === "function") {
      playPromise.catch(function () {});
    }
  }

  function setupGalleryVideos(root) {
    if (!root || videoObservers.has(root)) return;

    const videos = Array.prototype.slice.call(root.querySelectorAll("video"));
    if (!videos.length) return;

    const handleCanPlay = function (event) {
      if (activeVideos.has(event.currentTarget)) playVideo(event.currentTarget);
    };

    videos.forEach(function (video) {
      video.muted = true;
      video.defaultMuted = true;
      video.autoplay = true;
      video.playsInline = true;
      video.setAttribute("muted", "");
      video.setAttribute("autoplay", "");
      video.setAttribute("playsinline", "");
      video.addEventListener("canplay", handleCanPlay);
    });

    if (!("IntersectionObserver" in window)) {
      videos.forEach(function (video) {
        activeVideos.add(video);
        playVideo(video);
      });
      videoObservers.set(root, { observer: null, videos: videos, handleCanPlay: handleCanPlay });
      return;
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          const video = entry.target;
          if (entry.isIntersecting) {
            activeVideos.add(video);
            playVideo(video);
          } else {
            activeVideos.delete(video);
            video.pause();
          }
        });
      },
      { rootMargin: "160px 0px", threshold: 0.01 }
    );

    videos.forEach(function (video) {
      observer.observe(video);
    });

    videoObservers.set(root, { observer: observer, videos: videos, handleCanPlay: handleCanPlay });
  }

  function destroyGalleryVideos(root) {
    const state = videoObservers.get(root);
    if (!state) return;

    if (state.observer) state.observer.disconnect();
    state.videos.forEach(function (video) {
      activeVideos.delete(video);
      video.removeEventListener("canplay", state.handleCanPlay);
      video.pause();
    });
    videoObservers.delete(root);
  }

  function initGallery(root) {
    if (!root) return;

    setupGalleryVideos(root);
    if (instances.has(root) || !window.Swiper) return;

    const viewport = root.querySelector(".stellr-gallery__viewport");
    const wrapper = root.querySelector(".stellr-gallery__track, .stellr-product-main__gallery-track");
    if (!viewport) return;
    if (!wrapper) return;

    const section = root.closest(".stellr-gallery, .stellr-product-main");
    const previousButton = section ? section.querySelector(".stellr-gallery__button--prev") : null;
    const nextButton = section ? section.querySelector(".stellr-gallery__button--next") : null;
    const slidesMobile = parseFloat(root.dataset.slidesMobile) || 1.2;
    const slidesTablet = parseFloat(root.dataset.slidesTablet) || 3;
    const slidesDesktop = parseFloat(root.dataset.slidesDesktop) || 5;
    const mobileGap = 16;
    const tabletGap = 18;
    const desktopGap = 24;

    Array.prototype.forEach.call(wrapper.children, function (child) {
      if (!child.classList.contains("swiper-slide")) {
        child.classList.add("swiper-slide");
      }
    });

    const swiperOptions = {
      slidesPerView: slidesMobile,
      spaceBetween: mobileGap,
      speed: 650,
      grabCursor: true,
      watchOverflow: true,
      resistanceRatio: 0.82,
      keyboard: {
        enabled: true,
        onlyInViewport: true,
      },
      breakpoints: {
        750: {
          slidesPerView: slidesTablet,
          spaceBetween: tabletGap,
        },
        990: {
          slidesPerView: slidesDesktop,
          spaceBetween: desktopGap,
        },
      },
    };

    if (previousButton && nextButton) {
      swiperOptions.navigation = {
        prevEl: previousButton,
        nextEl: nextButton,
      };
    }

    const swiper = new window.Swiper(viewport, swiperOptions);

    instances.set(root, swiper);
  }

  function destroyGallery(root) {
    const swiper = instances.get(root);
    if (swiper) {
      swiper.destroy(true, true);
      instances.delete(root);
    }
    destroyGalleryVideos(root);
  }

  function initAll() {
    document.querySelectorAll("[data-stellr-swiper-gallery]").forEach(initGallery);
  }

  document.addEventListener("DOMContentLoaded", initAll);
  window.addEventListener("load", initAll);

  document.addEventListener("shopify:section:load", function (event) {
    event.target.querySelectorAll("[data-stellr-swiper-gallery]").forEach(initGallery);
  });

  document.addEventListener("shopify:section:unload", function (event) {
    event.target.querySelectorAll("[data-stellr-swiper-gallery]").forEach(destroyGallery);
  });

  document.addEventListener("shopify:block:select", function (event) {
    const gallery = event.target.closest("[data-stellr-swiper-gallery]");
    const slide = event.target.closest(".swiper-slide");
    const swiper = gallery ? instances.get(gallery) : null;

    if (swiper && slide) {
      swiper.slideTo(Array.prototype.indexOf.call(swiper.slides, slide), 450);
      playVideo(slide.querySelector("video"));
    }
  });

  document.addEventListener("visibilitychange", function () {
    activeVideos.forEach(function (video) {
      if (document.hidden) {
        video.pause();
      } else {
        playVideo(video);
      }
    });
  });
})();
